<template>
  <v-container>
    <div id="app">
      <v-app id="inspire">
        <v-content>
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <v-flex xs12 sm8 md6>
                <v-card class="elevation-12">
                  <v-toolbar dark color="#5ba322">
                    <v-toolbar-title>Passwort ändern</v-toolbar-title>
                    <div class="spacer"></div>
                    <span class="v-tooltip v-tooltip--right">
                    </span>
                  </v-toolbar>
                  <v-card-text>
                  <v-form
                      ref="form"
                      lazy-validation
                      class="mic_form">
                      <v-text-field
                        prepend-icon="lock"
                        name="password"
                        label="Neues Passwort"
                        id="password"
                        :rules="passwordRules"
                        type="password"
                        v-model="password"
                        @keydown.enter.prevent="update"
                        required>
                      </v-text-field>
                    </v-form>
                    <v-form
                      ref="form"
                      lazy-validation
                      class="mic_form">
                      <v-text-field
                        prepend-icon="lock"
                        name="passwordRepeat"
                        label="Neues Passwort wiederholen"
                        id="passwordRepeat"
                        :rules="passwordRepeatRules"
                        :class="{ 'is-invalid': submitted && !passwordRepeat }"
                        type="password"
                        v-model="passwordRepeat"
                        @keydown.enter.prevent="update"
                        required>
                      </v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#f5a900" @click="update" class="white--text">Speichern</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import {userService} from '../_services'
export default {
  data () {
    return {
      password: '',
      passwordRules: [
        v => !!v || 'Passwort ist ein Pflichfeld.',
        v => (!!v && !/^[a-zA-Z0-9- ]*$/.test(v)) || 'Das Passwort muss mindestens ein Sonderzeichen enthalten.',
        v => (!!v && /[A-Z]/.test(v)) || 'Das Passwort muss mindestens einen Großbuchstaben enthalten.',
        v => (!!v && v.length >= 8) || 'Das Passwort muss mindestens 8 Zeichne lang sein.'
      ],
      passwordRepeat: '',
      passwordRepeatRules: [
        v => !!v || 'Passwort widerholen ist ein Pflichfeld.',
        v => (v === this.password) || 'Passwörter stimmen nicht überein.'
      ],
      submitted: false
    }
  },
  methods: {
    update () {
      const {dispatch} = this.$store
      userService.changePassword(this.$router.currentRoute.params.token, this.password)
        .then(
          response => {
            console.log('test')
            dispatch('alert/success', 'Das neue Passwort wurde erfolgreich gespeichert.', {root: true})
            this.$router.push('/login')
          },
          error => {
            console.log(error)
            dispatch('alert/error', 'Fehler beim Speichern des neuen Passwortes.', {root: true})
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/login/ChangePasswordPage.vue